'use client';

import { NavigationCross, OperationsSearch } from '@energy-retailer/icons';
import { Combobox } from '@headlessui/react';
import { clsx } from 'clsx';
import { useFormContext } from 'react-hook-form';
import { twMerge } from 'tailwind-merge';

import { useJoinFormStore } from '@/stores/join-form-store/join-form-store';

import type { SearchIconProps } from './typeahead.types';
import type { FieldValues } from 'react-hook-form';

export const SearchIcon = <T extends FieldValues>({
  onClick,
  disabled = false,
  readOnly = false,
  field,
  variant = 'secondary',
}: SearchIconProps<T>) => {
  const { watch } = useFormContext<T>();
  const { property } = useJoinFormStore();

  const value = watch(field.name);

  const searchIconClassName = twMerge(
    clsx('size-icon-xs text-pink-500', {
      'text-gray-700': readOnly || disabled,
      'cursor-pointer': Boolean(value) && (!readOnly || !disabled),
    })
  );

  if (disabled) {
    return (
      <Combobox.Button className="pointer-events-none absolute inset-y-0 right-0 flex cursor-default items-center pr-a">
        <OperationsSearch className={searchIconClassName} />
      </Combobox.Button>
    );
  }

  return property.addressSearch === '' ? (
    <Combobox.Button
      className={twMerge(
        clsx(
          'pointer-events-none absolute inset-y-0 right-0 flex cursor-default items-center pr-a',
          {
            hidden: variant === 'primary',
          }
        )
      )}
    >
      <OperationsSearch className={searchIconClassName} />
    </Combobox.Button>
  ) : (
    <Combobox.Button
      onClick={onClick}
      type="button"
      aria-label="input clear button"
      className={twMerge(
        clsx('absolute inset-y-0 right-0 z-10 flex items-center pr-a', {
          'pointer-events-none': readOnly,
        })
      )}
    >
      <NavigationCross className={searchIconClassName} />
    </Combobox.Button>
  );
};
